export const isValidEmail = email => {
  return String(email)
    .toLowerCase()
    .match(/^([^\s@]+@[^\s@]+\.[a-zA-Z]{2,})$/);
};
